'use strict';

import template from '../../templates/changeLogs/Main.ejs';
import ChangeLogView from './ChangeLog.js';
import PaginatedList from 'commons/views/PaginatedList.js';
import loader from 'helpers/loader';

module.exports = PaginatedList.extend({
    views: [],
    events() {
        let parentEvents = _.isFunction(PaginatedList.prototype.events) ?
            PaginatedList.prototype.events() :
            PaginatedList.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'click .js-back': 'back'
        });
    },

    initialize(options) {
        this.options = _.defaults(options || {}, {
            company: null
        });

        this.views = [];

        this.collection.on('sync', this.render, this);
        this.collection.fetchPage(undefined, {validate: false});
        this.stopLoader = loader.startFullPage(this.$('table'));

        return this;
    },

    render() {
        this.$el.html(template({
            company:    this.options.company,
            total:      this.collection.length,
            pagination: this.collection.getPaginationInfo(),
            sort:       this.collection.getSort()
        }));

        this.collection.forEach(changeLog => {
            this.views.push(new ChangeLogView({
                model: changeLog,
                positions: this.options.positions,
                locations: this.options.locations,
                leaveTypes: this.options.leaveTypes
            }));

            this.$('.js-logs').append(_(this.views).last().$el);
        });

        this.stopLoader();
        return this;
    },

    back() {
        if (!this.options.company) {
            return;
        }

        history.go(-1);
    },

    navigate() {
        app.mainRouter.navigate(
            'logs/' + this.options.company.id, {trigger: true}
        );
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/changeLogs/Main.js